// extracted by mini-css-extract-plugin
export default {"logo_small":"HeaderLogo_logo_small__NEh2L","logo_large":"HeaderLogo_logo_large__IlyRT"};